import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import formMixin from 'mixins/user-form-mixin';
import validationMixin from 'mixins/validationMixin';
import CargomaticRadio from 'components/v2/forms/Radio';
import { showToast } from 'stores/ToastStore';
import SessionStore from 'stores/SessionStore';
import ROLES from 'constants/UserRoles';
import { Alert } from 'react-bootstrap';
import { humanize } from 'underscore.string';
import ReviewBankingModal from './review-banking-modal';
import Representative from './carrier-representative';
import EditableSection from '../../../v2/EditableSection';
import DescriptionListItem from '../../../v2/DescriptionListItem';
import { updateCarrier } from 'utils/CustomersAPIUtils';
import AccountSettings from './AccountSettings';
const VERIFIED = 'verified';
const PENDING = 'pending';
class BillingForm extends Component {
    constructor(props) {
        super(props);
        this.handleDismissAlert = () => {
            this.setState({ errors: [] });
        };
        this.onBankingModalClose = () => {
            this.setState({
                showReviewBankingModal: false,
            });
        };
        this.onOpenReviewBankingModal = () => {
            const { t } = this.props;
            const loggedInUser = SessionStore.getUser();
            if (loggedInUser.roles.includes(ROLES.FINANCE_ADMIN)) {
                this.setState({
                    showReviewBankingModal: true,
                });
            }
            else {
                showToast({
                    title: 'Error',
                    body: t('NEED_FINANCE_ADMIN_PERMISSION'),
                    level: 'error',
                });
            }
        };
        this.renderBankingInfoSummary = () => {
            var _a, _b, _c, _d;
            const { t } = this.props;
            return (React.createElement(React.Fragment, null,
                this.props.details.stripe_account_id && (React.createElement(React.Fragment, null,
                    React.createElement(DescriptionListItem, { label: t('ROUTING_NUMBER') }, this.state.routing || '-'),
                    React.createElement(DescriptionListItem, { label: t('ACCOUNT_NUMBER') }, this.state.account || '-'))),
                this.props.details.all_banking_info_approved &&
                    ((_a = this.props.details) === null || _a === void 0 ? void 0 : _a.is_partner_with_factoring_company) &&
                    ((_c = (_b = this.props.details) === null || _b === void 0 ? void 0 : _b.factoring_company_name) === null || _c === void 0 ? void 0 : _c.length) && (React.createElement(React.Fragment, null,
                    React.createElement(CargomaticRadio, { id: "partner_company_checkbox_form", className: "col-span-2", checked: this.props.details.is_partner_with_factoring_company, disabled: true, name: "partnerCompanyRadio1", value: this.props.details.is_partner_with_factoring_company, onChange: () => { } }, t('PARTNER_WITH_FACTORING_COMPANY')),
                    React.createElement("p", { className: "col-span-2" }, (_d = this.props.details) === null || _d === void 0 ? void 0 : _d.factoring_company_name)))));
        };
        this.renderBankingInfoForm = () => {
            var _a, _b, _c, _d;
            const { t } = this.props;
            return (React.createElement(React.Fragment, null,
                this.renderBankingInfoErrors(),
                this.props.details.stripe_account_id && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "" },
                        React.createElement("label", { className: "block mb-2 form-label" }, t('ROUTING_NUMBER')),
                        React.createElement("input", { className: "w-full mb-4 form-field", value: this.state.routing, placeholder: t('ROUTING_NUMBER'), onChange: (e) => this.setState({ routing: e.target.value }) })),
                    React.createElement("div", { className: "" },
                        React.createElement("label", { className: "block mb-2 form-label" }, t('ACCOUNT_NUMBER')),
                        React.createElement("input", { className: "w-full mb-4 form-field", value: this.state.account, placeholder: t('ACCOUNT_NUMBER'), onChange: (e) => this.setState({ account: e.target.value }) })))),
                this.props.details.all_banking_info_approved && (React.createElement("div", { className: "col-span-2" }, ((_a = this.props.details) === null || _a === void 0 ? void 0 : _a.is_partner_with_factoring_company) &&
                    ((_c = (_b = this.props.details) === null || _b === void 0 ? void 0 : _b.factoring_company_name) === null || _c === void 0 ? void 0 : _c.length) && (React.createElement(React.Fragment, null,
                    React.createElement(CargomaticRadio, { id: "partner_company_checkbox_form", checked: this.props.details.is_partner_with_factoring_company, disabled: true, name: "partnerCompanyRadio1", value: this.props.details.is_partner_with_factoring_company, onChange: () => { } }, t('PARTNER_WITH_FACTORING_COMPANY')),
                    React.createElement("p", { className: "mx-8" }, (_d = this.props.details) === null || _d === void 0 ? void 0 : _d.factoring_company_name))))),
                !this.props.details.all_banking_info_approved && (React.createElement("div", { className: "col-span-2 justify-self-center" },
                    React.createElement("button", { className: "button bg-orange-400 text-white px-8", onClick: this.onOpenReviewBankingModal }, t('REVIEW_BANKING_INFORMATION'))))));
        };
        this.state = {
            routing: '',
            account: '',
            legalEntity: '',
            showReviewBankingModal: false,
            errors: [],
        };
    }
    onUpdate() {
        if (this.props.onSave)
            this.props.onSave(this.state);
    }
    getValidationErrors() {
        const { t } = this.props;
        const accountErrors = [];
        const bankingRequiredFields = ['routing', 'account'];
        bankingRequiredFields.forEach((field) => {
            if (!this.state[field]) {
                accountErrors.push({
                    field: field,
                    value: this.state[field],
                    error: t('REQUIRED_FOR_BANKING'),
                });
            }
        });
        return accountErrors;
    }
    onSaveLegalEntity(value) {
        let accountErrors = [];
        const data = {};
        const sendBankAccount = this.state.routing || this.state.account;
        if (sendBankAccount)
            accountErrors = this.getValidationErrors();
        if (!value.errors.concat(accountErrors).length) {
            if (sendBankAccount) {
                data.routing = this.state.routing;
                data.account = this.state.account;
            }
            delete value.errors;
            if (value.type === 'individual') {
                delete value.business_name;
                delete value.business_tax_id;
            }
            data.legal_entity = value;
            data.userId = this.props.details.id;
            this.props.onSave(data);
            return true;
        }
        this.setState({ errors: accountErrors });
        return false;
    }
    renderBankingInfoErrors() {
        const { errors } = this.state;
        if (errors.length === 0) {
            return null;
        }
        return (React.createElement("div", { className: "col-span-2" },
            React.createElement(Alert, { bsStyle: "danger", onDismiss: this.handleDismissAlert },
                React.createElement("ul", null, errors.map((error, i) => (React.createElement("li", { key: i },
                    humanize(error.field),
                    ": ",
                    humanize(error.error))))))));
    }
    render() {
        const { t } = this.props;
        const details = this.props.details;
        let currentAccount = t('NO_BANK_ACCOUNT_REGISTERED');
        const bankAccounts = details.bank_accounts.external_accounts || [];
        const accountData = bankAccounts[0];
        let verified = 'unverified';
        let linkToStripeAccount = '';
        if (details.stripe_account_id) {
            const stripeId = details.stripe_account_id;
            const stripeUrl = `${STRIPE_URL}/applications/users/${stripeId}`;
            linkToStripeAccount = (React.createElement("a", { href: stripeUrl, target: "_stripe", title: "Stripe ID", className: "stripeId" }, t('VIEW_IN_STRIPE')));
        }
        else {
            currentAccount += ` ${t('ADD_BILLING_INFORMATION')}`;
        }
        if (accountData) {
            currentAccount = `${accountData.bank_name} - ending in ${accountData.last4}`;
        }
        if (details.stripe_verification) {
            verified = details.stripe_verification.status;
        }
        const canEdit = !!SessionStore.hasFinanceAdminRole();
        const onCarrierAccountSave = async (userId, updates = {}) => {
            const payload = Object.assign({ _id: userId }, updates);
            await updateCarrier(userId, payload);
            return false;
        };
        return (React.createElement(React.Fragment, null,
            this.state.showReviewBankingModal && (React.createElement(ReviewBankingModal, { show: this.state.showReviewBankingModal, onClose: this.onBankingModalClose, onConfirmDetails: this.props.onHandleBankingInfoAccept, onDeclineDetails: this.props.onHandleBankingInfoDecline, sensitiveDocumentData: this.props.sensitiveDocumentData, onGetVerificationData: this.props.onGetVerificationData, partnerWithFactoringCompany: this.props.details.is_partner_with_factoring_company, partnerFactoringCompanyName: this.props.details.factoring_company_name })),
            React.createElement("div", { className: "lg:grid lg:grid-cols-2 lg:gap-4" },
                React.createElement(AccountSettings, { data: details, onUpdateCarrier: onCarrierAccountSave, canEdit: canEdit }),
                React.createElement(EditableSection, { title: t('BANKING_INFORMATION'), canEdit: canEdit }, (editing, saving, onSaveSuccess) => {
                    if (saving) {
                        this.onUpdate();
                        onSaveSuccess();
                    }
                    return (React.createElement("div", { className: "grid grid-cols-2 gap-4" },
                        React.createElement(DescriptionListItem, { label: t('CURRENTLY'), className: "col-span-2" }, currentAccount),
                        !editing && this.renderBankingInfoSummary(),
                        editing && this.renderBankingInfoForm(),
                        !this.props.details.all_banking_info_approved &&
                            canEdit &&
                            !editing && (React.createElement("div", { className: "col-span-2 justify-self-center" },
                            React.createElement("button", { className: "button bg-orange-400 text-white px-8", onClick: this.onOpenReviewBankingModal }, t('REVIEW_BANKING_INFORMATION'))))));
                }),
                verified !== VERIFIED && verified !== PENDING && (React.createElement(Representative, { verified: verified, onSave: (value) => this.onSaveLegalEntity(value), carrier_id: this.props.details._id, linkToStripeAccount: linkToStripeAccount })))));
    }
}
BillingForm.propTypes = {
    details: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired,
    sensitiveDocumentData: PropTypes.array,
    onHandleBankingInfoAccept: PropTypes.func.isRequired,
    onHandleBankingInfoDecline: PropTypes.func.isRequired,
    onGetVerificationData: PropTypes.func.isRequired,
};
export default withTranslation()(formMixin(validationMixin(BillingForm)));
